export default function timeRangesToArray (timeRanges) {
  const arr = [];

  if (timeRanges instanceof TimeRanges) {
    for (let i = 0; i < timeRanges.length; i++) {
      arr.push([
        timeRanges.start(i),
        timeRanges.end(i)
      ]);
    }
  }

  return arr;
}
